exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, ".asseco-card{font-family:Roboto,sans-serif}", ""]);

// exports
